import { render, staticRenderFns } from "./MySupport.vue?vue&type=template&id=b30fd5a2&scoped=true"
import script from "./MySupport.vue?vue&type=script&lang=js"
export * from "./MySupport.vue?vue&type=script&lang=js"
import style0 from "./MySupport.vue?vue&type=style&index=0&id=b30fd5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30fd5a2",
  null
  
)

export default component.exports